import { IWidgetDefinition, IWidget } from '../../common/core';
import { TextFacetData, TextFacetWidgetDefinition, TextFacetItem } from '../textfacet.widget/textfacet';
import { IFuseTextFacetSettings, IFuseTextFacetState } from './settings';

const template = require('./fuse-textfacet.html');
const styles = require('./fuse-textfacet.scss').toString();

class FuseTextFacetData extends TextFacetData {
  showSearchDialog = false;
  modalSelectedState: any;

  /**
   * All more items
   */
  moreSearchTermResults: TextFacetItem[];

  /**
   * Currently visible more items
   */
  moreSearchTermResultsCurrent: TextFacetItem[];

  /**
   * Page size for more items
   */
  moreSearchTermPerPage = 10;

  focusBlurPlugin: any;

  constructor(public widget: IWidget<FuseTextFacetData, IFuseTextFacetSettings, IFuseTextFacetState>) {
    super(widget);

    this.focusBlurPlugin = {
      afterViewInit(el) {
        var el = el.$element.nativeElement;
        el.focus();
        el.blur();
      }
    };
  }

  _globalMoreKeydownHandler(event) {
    super._globalMoreKeydownHandler(event);
    if (this.showSearchDialog && event.which == 27) { // Esc
      // this.onDialogCancelClick();
      this.onDialogSaveClick();
    }
  }

  checkItems(terms: TextFacetItem[], setState: boolean = true) {
    // `setTimeout` used to fix issue in IE when `checked` goes to not sync state with [checked]
    setTimeout(() => {
      terms.forEach(term => this._check(term));

      this._onChange();
      if (setState) {
        this._setState();
      } else {
        this.setTerms(this.lastTerms, 0);
      }

      terms.forEach(term => this._trackAction(term));
    });
  }

  searchTermResults(searchString: string, maxFacets?: number, onFacetsRecieved?: (terms: TextFacetItem[]) => void, ignoreVisibleItems: boolean = false) {
    this.clearMoreItems();

    maxFacets = maxFacets || this.moreMaxFacets;
    if (this._searchTermResultsTimeout) {
      clearTimeout(this._searchTermResultsTimeout);
    }

    this.moreLoading = true;
    this._searchTermResultsTimeout = setTimeout(() => {
      this.__searchTermResults(searchString, maxFacets, onFacetsRecieved, ignoreVisibleItems);
    }, 200);
  }

  __searchTermResults(searchString: string, maxFacets: number, onFacetsRecieved: (terms: TextFacetItem[]) => void, ignoreVisibleItems: boolean = false) {
    const filterExp = '*' + searchString + '*';

    if (this._searchTermResultsXhr) {
      this._searchTermResultsXhr['_aborted'] = true;
      if (this._searchTermResultsXhr.abort) {
        this._searchTermResultsXhr.abort();
      }
    }

    this.filterFacets(maxFacets, filterExp, (terms: TextFacetItem[], other: number) => {
      this._searchTermResultsXhr = null;
      terms = this.adjustFacets(terms, searchString || '');

      this.searchMore = !!other;
      if (onFacetsRecieved) {
        onFacetsRecieved(terms);
      } else {
        this.onFacetsRecieved(terms);
      }

      this.moreLoading = false;
    }, ignoreVisibleItems).then(xhr => {
      this._searchTermResultsXhr = xhr;
    });
  }

  onFacetsRecieved(terms: TextFacetItem[]) {
    this.allSearchTermResults = terms;
  }

  setTerms(terms: TextFacetItem[], otherTermsCount: number) {
    super.setTerms(terms, otherTermsCount);

    if (terms) {
      terms.forEach(t => {
        t['id'] = `fuse-f-${this.name || this.widget.id}_${t.term}`;
      });
    }

    if (this.widget.service.g['showAllFacets'] && this.widget.service['_defaultFilters']) {
      this.widget.service['_defaultFilters'].then(resp => {
        var facets = resp.facets || {};
        var facet = facets[this.fieldWithSort] || {};
        var allTerms = JSON.parse(JSON.stringify(facet.terms || []));

        var tMap = {};
        terms.forEach(t => {
          tMap[t.term] = t;
        });

        allTerms.forEach(t => {
          t['id'] = `fuse-f-${this.name || this.widget.id}_${t.term}`;
          if (tMap[t.term]) {
            t.count = tMap[t.term].count;
            t._count = tMap[t.term]._count;
          } else {
            t.count = '0';
            t._count = '0';
          }
        });

        super.setTerms(allTerms, otherTermsCount);
      });
    }
  }

  addMissedSelectedTerm(term: string) {
    var res = super.addMissedSelectedTerm(term);

    if (this.moreSearchTermResultsCurrent) {
      var matchedTerm = this.moreSearchTermResultsCurrent.find(t => {
        return t.term == term;
      });
      if (matchedTerm) {
        res.count = matchedTerm.count;
      }
    }

    return res;
  }

  clearMoreItems() {
    this.moreSearchTermResultsCurrent = null;
    this.moreSearchTermResults = null;
  }

  onMoreClick() {
    this.showSearchDialog = true;
    this.searchTermString = '';
    this.modalSelectedState = JSON.parse(JSON.stringify(this.widget.state.selected || {}));
    this.clearMoreItems();
    this.searchTermResults('');
  }

  hasMoreItems() {
    if (this.moreSearchTermResults && this.moreSearchTermResultsCurrent) {
      return this.moreSearchTermResults.length > this.moreSearchTermResultsCurrent.length;
    } else if (this.showSearchDialog) {
      return this.searchMore; // has more items in more modal
    } else {
      return this.show_more; // has more itema (in mobile modal)
    }
  }
  showMoreItems(defaultNumberOfItems) {
    if (this.moreSearchTermResults && this.moreSearchTermResultsCurrent) {
      this.moreSearchTermResultsCurrent = this.moreSearchTermResults.slice(0, this.moreSearchTermResultsCurrent.length + this.moreSearchTermPerPage);
      this.selectShowMoreFocusBlurItem(this.moreSearchTermResultsCurrent.length - this.moreSearchTermPerPage - 1);
    } else {
      this.searchTermResults(this.searchTermString, 1000, (terms) => {
        this.moreSearchTermResults = terms;
        this.moreSearchTermResultsCurrent = terms.slice(0, defaultNumberOfItems + this.moreSearchTermPerPage);
        this.selectShowMoreFocusBlurItem(this.moreSearchTermResultsCurrent.length - this.moreSearchTermPerPage - 1);
      });
    }
  }

  /**
   * focus/blur item, so next 'tab' will focus next item
   */
  selectShowMoreFocusBlurItem(index) {
    this.moreSearchTermResultsCurrent.forEach(x => {
      delete x['focusBlur'];
    });
    if (this.moreSearchTermResultsCurrent && this.moreSearchTermResultsCurrent[index]) {
      this.moreSearchTermResultsCurrent[index]['focusBlur'] = true;
    }
  }

  onDialogOverlayClick() {
    // this.onDialogCancelClick();
    this.onDialogSaveClick();
  }

  onDialogWrapperClick(e: Event) {
    e.stopPropagation();
  }

  /*
  onDialogCancelClick() {
    this.showSearchDialog = false;

    this.allSearchTermResults = [];
    this.clearMoreItems();

    this.widget.state.selected = this.widget.state.selected || {};
    for (var key in this.widget.state.selected) {
      delete this.widget.state.selected[key];
    }

    for (var key in this.modalSelectedState || {}) {
      this.widget.state.selected[key] = true;
    }
    this.modalSelectedState = null;

    this.setTerms(this.lastTerms, 0);

    this._setState();
  }
  */

  onDialogSaveClick() {
    this.showSearchDialog = false;
    this.setTerms(this.lastTerms, 0);
    this.widget.service.setState();
  }
};

export const FuseTextFacetWidgetDefinition: IWidgetDefinition<FuseTextFacetData, IFuseTextFacetSettings, IFuseTextFacetState> = {
  ...TextFacetWidgetDefinition,
  init(w) {
    w.data = new FuseTextFacetData(w);

    if (w.service.g['showAllFacets']) {
      if (!w.service['_filterFields']) {
        w.service['_filterFields'] = [];
      }
      w.service['_filterFields'].push(w.d.fieldWithSort);
    }
  },
  template: template,
  styles: styles,
};
export { FuseTextFacetData };